import type { ButtonHTMLAttributes } from 'react';
import { joinCss } from '@/shared/lib/css-utils';
import css from './pagination.module.scss';

type PaginationButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
};

export const PaginationButton = ({
  active = false,
  className,
  children,
  ...restProps
}: PaginationButtonProps) => (
  <button
    className={joinCss(css.button, active && css.isActive, className)}
    type="button"
    {...restProps}
  >
    {children}
  </button>
);

type PaginationProps = {
  children: React.ReactNode;
  className?: string;
};

export const Pagination = ({ children, className }: PaginationProps) => (
  <nav className={joinCss(css.nav, className)}>{children}</nav>
);
